import { graphql } from 'react-relay';

import { commit } from './commit';

const mutation = graphql`
  mutation deleteHappeningMutation($input: DeleteHeroOfferInput!) {
    deleteHeroOffer(input: $input) {
      destroyedHeroOfferId
      lists {
        ...HappeningsContainer_lists
      }
    }
  }
`;

const deleteHappening = (environment, happeningId, listsId, args = {}) => {
  return commit(environment, {
    mutation,
    variables: {
      input: {
        id: happeningId,
      },
    },
    configs: [
      {
        type: 'RANGE_DELETE',
        parentID: listsId,
        connectionKeys: [{ key: 'HappeningsContainer_heroOffers' }],
        pathToConnection: ['lists', 'heroOffers'],
        deletedIDFieldName: 'destroyedHeroOfferId',
      },
    ],
    ...args,
  });
};

export default deleteHappening;
